import React, { useState } from "react";
import { GoPlus } from "react-icons/go";
import { FiMinus } from "react-icons/fi";

const faqs = [
  {
    question: "What legal services do you offer?",
    answer:
      "We offer legal counsel in corporate, employment, intellectual property, mergers and acquisitions, and litigation matters.",
  },
  {
    question: "How do I book a consultation?",
    answer:
      "You can book online using our scheduling form, call us directly, or request a callback. ",
    cta: "Book Now",
  },
  {
    question: "Do you offer a free first consultation?",
    answer:
      "Yes, we offer a complimentary initial consultation to understand your legal needs.",
  },
  {
    question: "Are your services available nationwide?",
    answer:
      "Yes, we serve clients across India through our offices and remote consultations.",
  },
  {
    question: "How do you charge for your services?",
    answer:
      "Our billing is flexible: hourly, fixed-fee, or retainer-based depending on your requirement.",
  },
];

export default function FaqSection() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="bg-[#E7EDF4] py-16 px-4 md:px-20">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-bold text-5xl xl:text-6xl textblack text-center">
          Frequently Asked Questions
        </h1>
        <p className="text-center textblack mt-4 mb-10 textblack">
          Trusted by individuals and businesses for sound legal advice, strategic.
        </p>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`border rounded-lg ${activeIndex === index ? "bg-[#fff8ec] border-[#f2c46f]" : "bg-white"
                }`}
            >
              <button className="flex justify-between items-center w-full px-6 py-4 text-left text-gray-900 font-medium" onClick={() => toggle(index)}>

                <h1 className="text-xl md:text-2xl font-semibold">{faq.question}</h1>
                <span className="text-xl font-bold">
                  {activeIndex === index ?
                    <div className="border border-[#f2c46f] textcolor rounded-md p-1">
                      <FiMinus size={22} />
                    </div>
                    :
                    <div className="border rounded-md p-1">
                      <GoPlus size={22} />
                    </div>
                  }
                </span>
              </button>

              {activeIndex === index && (
                <div className="px-6 pb-4 text-sm textblack">
                  {faq.answer}
                  {faq.cta && (
                    <p className="text-[#d6a545] ml-1 font-medium hover:underline">{faq.cta}</p>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
